export const demo_SceneGraph_Thinking_ImageBoxes = [
  {
    id: "8437d80c-ef22-46c9-b88b-58148cfe0420",
    label: "RGB(35,35,35)",
    type: "ImageBox",
    description: "Size: 5607297 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 0,
      y: 0,
    },
    bottomRight: {
      x: 799.7093023255815,
      y: 599.7093023255815,
    },
  },
  {
    id: "c1b415e3-c535-4115-96b5-76ea84a85e5d",
    label: "RGB(129,239,255)",
    type: "ImageBox",
    description: "Size: 7983 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 0,
      y: 145.93023255813955,
    },
    bottomRight: {
      x: 247.96511627906978,
      y: 286.6279069767442,
    },
  },
  {
    id: "7c5e920b-215b-493d-af05-df1b18824fab",
    label: "RGB(247,209,253)",
    type: "ImageBox",
    description: "Size: 967 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 450.58139534883725,
      y: 230.2325581395349,
    },
    bottomRight: {
      x: 460.1744186046512,
      y: 240.69767441860466,
    },
  },
  {
    id: "a9a47e0f-7495-4857-87a6-ec588433f47f",
    label: "RGB(248,210,255)",
    type: "ImageBox",
    description: "Size: 3439 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 378.7790697674419,
      y: 234.59302325581396,
    },
    bottomRight: {
      x: 410.1744186046512,
      y: 260.1744186046512,
    },
  },
  {
    id: "1ac2d552-3b4c-463f-9aba-28c287589751",
    label: "RGB(36,36,36)",
    type: "ImageBox",
    description: "Size: 461 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 392.7325581395349,
      y: 239.82558139534885,
    },
    bottomRight: {
      x: 403.7790697674419,
      y: 247.38372093023258,
    },
  },
  {
    id: "bfb66193-07d6-47ef-9b00-344a2f4f1fc6",
    label: "RGB(45,43,45)",
    type: "ImageBox",
    description: "Size: 118 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 403.19767441860466,
      y: 243.0232558139535,
    },
    bottomRight: {
      x: 407.55813953488376,
      y: 247.96511627906978,
    },
  },
  {
    id: "a7dc3ee1-5d3b-41af-a57e-b4efb5afd9ba",
    label: "RGB(43,42,44)",
    type: "ImageBox",
    description: "Size: 55 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 389.8255813953489,
      y: 246.80232558139537,
    },
    bottomRight: {
      x: 392.4418604651163,
      y: 249.4186046511628,
    },
  },
  {
    id: "e7fb6df4-c5ca-4905-a430-f1e380be79f0",
    label: "RGB(245,245,245)",
    type: "ImageBox",
    description: "Size: 14134 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 270.93023255813955,
      y: 252.32558139534885,
    },
    bottomRight: {
      x: 331.10465116279073,
      y: 422.093023255814,
    },
  },
  {
    id: "33a9d3da-c106-4c06-85cb-3a191107f611",
    label: "RGB(38,38,38)",
    type: "ImageBox",
    description: "Size: 7419 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 274.1279069767442,
      y: 254.9418604651163,
    },
    bottomRight: {
      x: 324.4186046511628,
      y: 286.04651162790697,
    },
  },
  {
    id: "7d2cac19-7519-4d6a-b950-baa11eb3353b",
    label: "RGB(45,45,45)",
    type: "ImageBox",
    description: "Size: 5593 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 282.55813953488376,
      y: 270.34883720930236,
    },
    bottomRight: {
      x: 318.60465116279073,
      y: 309.3023255813954,
    },
  },
  {
    id: "1b2c85cb-beec-4a56-bbfb-36135f49aa8b",
    label: "RGB(37,37,37)",
    type: "ImageBox",
    description: "Size: 3939 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 287.7906976744186,
      y: 277.0348837209302,
    },
    bottomRight: {
      x: 317.7325581395349,
      y: 293.8953488372093,
    },
  },
  {
    id: "499ce8c3-019d-4f4a-aa2b-9b9c02b58684",
    label: "RGB(245,207,252)",
    type: "ImageBox",
    description: "Size: 3507 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 439.5348837209303,
      y: 291.5697674418605,
    },
    bottomRight: {
      x: 463.66279069767444,
      y: 317.1511627906977,
    },
  },
  {
    id: "d54201ca-eab4-4ad8-beea-2d62eb372511",
    label: "RGB(128,237,254)",
    type: "ImageBox",
    description: "Size: 6383 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 0,
      y: 293.60465116279073,
    },
    bottomRight: {
      x: 227.61627906976744,
      y: 325.58139534883725,
    },
  },
  {
    id: "aa04dedc-443f-4e93-b880-4a2d04595d7a",
    label: "RGB(38,38,38)",
    type: "ImageBox",
    description: "Size: 85 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 450,
      y: 297.093023255814,
    },
    bottomRight: {
      x: 455.81395348837214,
      y: 300.58139534883725,
    },
  },
  {
    id: "55441763-2b15-4701-bd46-b4a6bbb3457e",
    label: "RGB(36,35,36)",
    type: "ImageBox",
    description: "Size: 333 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 456.3953488372093,
      y: 298.8372093023256,
    },
    bottomRight: {
      x: 460.75581395348837,
      y: 312.2093023255814,
    },
  },
  {
    id: "28efd6ed-180b-4d66-a441-89e1c5358621",
    label: "RGB(240,240,240)",
    type: "ImageBox",
    description: "Size: 15 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 240.40697674418607,
      y: 303.19767441860466,
    },
    bottomRight: {
      x: 241.56976744186048,
      y: 304.9418604651163,
    },
  },
  {
    id: "e2b3b42b-103f-41b3-a078-7f12ceb000c7",
    label: "RGB(252,252,252)",
    type: "ImageBox",
    description: "Size: 1775 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 240.98837209302326,
      y: 303.48837209302326,
    },
    bottomRight: {
      x: 295.05813953488376,
      y: 339.5348837209302,
    },
  },
  {
    id: "d018c3bd-672c-4ce2-83f6-3c5bb3835f44",
    label: "RGB(249,210,255)",
    type: "ImageBox",
    description: "Size: 460 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 367.7325581395349,
      y: 303.48837209302326,
    },
    bottomRight: {
      x: 374.7093023255814,
      y: 310.4651162790698,
    },
  },
  {
    id: "54507f2f-6729-43fa-b8b3-bccf85b3748d",
    label: "RGB(37,37,37)",
    type: "ImageBox",
    description: "Size: 193 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 450.58139534883725,
      y: 303.48837209302326,
    },
    bottomRight: {
      x: 456.6860465116279,
      y: 306.9767441860465,
    },
  },
  {
    id: "52e7ce1e-b2a1-45d8-aa84-cdd88d91a729",
    label: "RGB(43,42,45)",
    type: "ImageBox",
    description: "Size: 18 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 445.34883720930236,
      y: 304.3604651162791,
    },
    bottomRight: {
      x: 447.3837209302326,
      y: 305.5232558139535,
    },
  },
  {
    id: "b2e746bd-cf8f-4f23-94b1-c918165d3e90",
    label: "RGB(39,38,39)",
    type: "ImageBox",
    description: "Size: 265 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 443.31395348837214,
      y: 308.13953488372096,
    },
    bottomRight: {
      x: 450.29069767441865,
      y: 314.24418604651163,
    },
  },
  {
    id: "01573caf-8f45-49cc-a19c-3139690e3d75",
    label: "RGB(242,242,242)",
    type: "ImageBox",
    description: "Size: 18 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 347.9651162790698,
      y: 313.95348837209303,
    },
    bottomRight: {
      x: 349.4186046511628,
      y: 315.69767441860466,
    },
  },
  {
    id: "c425f154-05fa-4939-8645-b89deb568db6",
    label: "RGB(251,251,251)",
    type: "ImageBox",
    description: "Size: 1382 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 305.81395348837214,
      y: 314.24418604651163,
    },
    bottomRight: {
      x: 348.546511627907,
      y: 338.66279069767444,
    },
  },
  {
    id: "e395a0b0-2b2e-4d26-80df-9e3581183641",
    label: "RGB(245,245,245)",
    type: "ImageBox",
    description: "Size: 1926 pixels",
    imageUrl: "/images/art/Untitled_Artwork 258.png",
    topLeft: {
      x: 302.3255813953489,
      y: 371.51162790697674,
    },
    bottomRight: {
      x: 368.8953488372093,
      y: 391.5697674418605,
    },
  },
];
